
import { productsData } from '../../../mocks/products';

export default function Products() {
  return (
    <section id="products" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Nuestros Productos
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Soluciones certificadas CE para infraestructura crítica, fabricadas con los más altos estándares de calidad europea
          </p>
        </div>

        {/* ENERGÍA CRÍTICA (UPS) */}
        <div className="mb-20">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center">
            <span className="w-1.5 h-8 bg-blue-900 mr-4 rounded-full"></span>
            Energía Crítica (UPS)
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
            {productsData.ups.map((product, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group">
                <div className="aspect-square w-full h-64 overflow-hidden bg-slate-100">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="text-xs font-semibold text-blue-900 mb-2 uppercase tracking-wide">
                    {product.category}
                  </div>
                  <h4 className="text-lg font-bold text-slate-900 mb-3">
                    {product.name}
                  </h4>
                  <p className="text-sm text-slate-600 mb-4 leading-relaxed">
                    {product.description}
                  </p>
                  <button className="w-full bg-slate-900 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-blue-900 transition-colors whitespace-nowrap">
                    Ver Ficha Técnica
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* INDUSTRIAL */}
        <div className="mb-20">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center">
            <span className="w-1.5 h-8 bg-blue-900 mr-4 rounded-full"></span>
            Industrial
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
            {productsData.industrial.map((product, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group">
                <div className="aspect-square w-full h-64 overflow-hidden bg-slate-100">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="text-xs font-semibold text-blue-900 mb-2 uppercase tracking-wide">
                    {product.category}
                  </div>
                  <h4 className="text-lg font-bold text-slate-900 mb-3">
                    {product.name}
                  </h4>
                  <p className="text-sm text-slate-600 mb-4 leading-relaxed">
                    {product.description}
                  </p>
                  <button className="w-full bg-slate-900 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-blue-900 transition-colors whitespace-nowrap">
                    Ver Ficha Técnica
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ALMACENAMIENTO */}
        <div>
          <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center">
            <span className="w-1.5 h-8 bg-blue-900 mr-4 rounded-full"></span>
            Almacenamiento
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
            {productsData.storage.map((product, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group">
                <div className="aspect-square w-full h-64 overflow-hidden bg-slate-100">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="text-xs font-semibold text-blue-900 mb-2 uppercase tracking-wide">
                    {product.category}
                  </div>
                  <h4 className="text-lg font-bold text-slate-900 mb-3">
                    {product.name}
                  </h4>
                  <p className="text-sm text-slate-600 mb-4 leading-relaxed">
                    {product.description}
                  </p>
                  <button className="w-full bg-slate-900 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-blue-900 transition-colors whitespace-nowrap">
                    Ver Ficha Técnica
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SECTORES */}
        <div className="mt-24 bg-white rounded-2xl p-12 shadow-lg">
          <h3 className="text-2xl font-bold text-slate-900 mb-8 text-center">
            Sectores que Servimos
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {[
              { name: 'Data Centers', icon: 'ri-server-line' },
              { name: 'Telecomunicaciones', icon: 'ri-signal-tower-line' },
              { name: 'Industria', icon: 'ri-factory-line' },
              { name: 'Energía', icon: 'ri-flashlight-line' },
              { name: 'Gobierno', icon: 'ri-government-line' },
              { name: 'Infraestructura Crítica', icon: 'ri-building-line' }
            ].map((sector, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <i className={`${sector.icon} text-3xl text-blue-900`}></i>
                </div>
                <div className="text-sm font-medium text-slate-700">
                  {sector.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
